import debug from 'bows';

const log = debug('overlay');

export default class {
	/**
	 * Menu constructor
	 */
	constructor( opts = {} ) {
		this.opts = Object.assign( {
			overlay: '.overlay',
			classes: {
				open: 'overlay--open',
				body: 'fixed',
			},
			openers: [
				'.header__search'
			],
			closers: [
				'.overlay__close'
			],
			focused: 'input[type="text"]'
		}, opts );

		this.node  = (typeof this.opts.overlay === 'string') ? document.querySelector(this.opts.overlay) : this.opts.overlay;

		if ( ! this.node ) {
			log('.overlay missing, abort!');
			return;
		}

		this.opened = false;

		// Openers and togglers
		this.opener = null;
		this.openers = Array.from(document.querySelectorAll(this.opts.openers.join(', ' )));

		this.closer = null;
		this.closers = Array.from(document.querySelectorAll(this.opts.closers.join(', ')));

		if ( this.openers.length > 0 ) {
			let boundOpenClick = (e) => {
				if ( e && e.preventDefault ) {
					e.preventDefault();
				}

				this.opener = e.target;
				this.open();
			}

			this.openers.forEach((opener) => {
				opener.addEventListener('click', boundOpenClick);
			});
		}

		if ( this.closers.length > 0 ) {
			let boundCloseClick = (e) => {
				log('boundCloseClick');
				if ( e && e.preventDefault ) {
					e.preventDefault();
				}

				this.closer = e.target;
				this.close();
			}

			this.closers.forEach((closer) => {
				log(closer);
				closer.addEventListener('click', boundCloseClick);
			});
		}

		// focused element on open
		this.focused = ( typeof this.opts.focused === 'string' ) ? this.node.querySelector( this.opts.focused ) : this.opts.focused;

		// listener for esc key
		this.keyup = (e) => {
			if (this.opened && e.key === 'Escape') {
				this.close(this.initOpened);
			}
		};
	}

	/**
	 * Open the overlay
	 */
	open() {
		this.opened = true;
		this.node.classList.add(this.opts.classes.open);
		document.addEventListener('keyup', this.keyup); // start listening for esc key
		// document.body.classList.add(this.opts.classes.body);

		if ( this.focused ) {
			this.focused.focus();
			this.focused.select();
		}

		log('open');
	}

	/**
	 * Close the overlay
	 */
	close() {
		// 1. Remove listener for esc key
		document.removeEventListener('keyup', this.keyup); // stop listening for esc key

		this.node.classList.remove(this.opts.classes.open);
		// document.body.classList.remove(this.opts.classes.body);

		if ( this.opener ) {
			this.opener.focus();
		}

		this.opened = false; // internal flag
		log('closed');
	}

	/**
	 * Toggle the overlay
	 */
	toggle() {
		return ( this.opened === false ) ? this.open() : this.close();
	}
}
